import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var UploadPortfolioImageAction = function () {

}


UploadPortfolioImageAction.prototype = {

	uploadPortfolioImage: function (data) {

		restClient.uploadPortfolioImage(data, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else{
					AppDispatcher.dispatch({
						actionType: Constant.UPLOAD_PORTFOLIO_IMAGE,
						data: error
					});
				}
			} else {
				response['status']= 200;
				AppDispatcher.dispatch({
					actionType: Constant.UPLOAD_PORTFOLIO_IMAGE,
					data: response
				});
			}
		})
	}
}

export default new UploadPortfolioImageAction();